if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfoSingle extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      quantityInputSticky = undefined;
      quantityFormSticky = undefined;
      cartUpdateUnsubscriber = undefined;

      constructor() {
        super();
        this.quantityInput = this.querySelector('.quantity__input-primary');
        this.quantityInputSticky = this.querySelector('.quantity__input-sticky');
      }

      connectedCallback() {
        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
      }

      initQuantityHandlers() {
        if (!this.quantityInput && !this.quantityInputSticky) return;

        this.quantityForm = this.querySelector('.product-form__quantity-primary') || this.querySelector('[id^="Quantity-Form-"]');
        this.quantityFormSticky = this.querySelector('.product-form__quantity-sticky') || this.querySelector('[id^="Quantity-Form-"][id$="-sticky"]');

        this.setQuantityBoundries();

        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      setQuantityBoundries() {
        const input = this.quantityInput || this.quantityInputSticky;
        if (!input) return;

        const data = {
          cartQuantity: input.dataset.cartQuantity ? parseInt(input.dataset.cartQuantity) : 0,
          min: input.dataset.min ? parseInt(input.dataset.min) : 1,
          max: input.dataset.max ? parseInt(input.dataset.max) : null,
          step: input.step ? parseInt(input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? null : data.max - data.cartQuantity;

        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        [this.quantityInput, this.quantityInputSticky].forEach((quantityInput) => {
          if (!quantityInput) return;
          quantityInput.min = min;
          quantityInput.value = min;
          if (max !== null) quantityInput.max = max;
          else quantityInput.removeAttribute('max');
        });

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((error) => console.error(error));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput && !this.quantityInputSticky) return;

        const quantityFormUpdated =
          html.getElementById(`Quantity-Form-${sectionId}`) ||
          html.getElementById(`Quantity-Form-${sectionId}-sticky`);

        if (!quantityFormUpdated) {
          this.setQuantityBoundries();
          return;
        }

        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];

        selectors.forEach((selector) => {
          const current = this.quantityForm?.querySelector(selector);
          const currentSticky = this.quantityFormSticky?.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);

          if (!updated || (!current && !currentSticky)) return;

          if (selector === '.quantity__input') {
            ['data-cart-quantity', 'data-min', 'data-max', 'step'].forEach((attribute) => {
              const valueUpdated = updated.getAttribute(attribute);
              [current, currentSticky].forEach((target) => {
                if (!target) return;
                if (valueUpdated !== null) target.setAttribute(attribute, valueUpdated);
                else target.removeAttribute(attribute);
              });
            });
          } else {
            if (current) current.innerHTML = updated.innerHTML;
            if (currentSticky) currentSticky.innerHTML = updated.innerHTML;
          }
        });

        this.setQuantityBoundries();
      }

      get productForm() {
        return this.querySelector('product-form');
      }
    }
  );
}
